import { Component, OnInit } from '@angular/core';
import { MyFeedsServiceService } from './my-feeds-services/my-feeds-service.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from "src/modules/base/services/loader.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-my-feeds',
    templateUrl: './my-feeds.component.html',
    styleUrls: ['./my-feeds.component.scss'],
    standalone: false
})
export class MyFeedsComponent implements OnInit {
  _medlineDetails: any=[];
  radioArray: any;
  _value: any = "";
  search: any = "";
  code: any = "";
  codeArrays:any ={};
  constructor(
    private service: MyFeedsServiceService,
    private alert: AlertsService,
    private baseService: BaseService,
    private router: Router,
    public route: ActivatedRoute,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    var cardData = JSON.parse(sessionStorage.getItem('currentData'));
    let role = localStorage.CURRENT_ROLE?JSON.parse(localStorage.CURRENT_ROLE):null;
    if(role.role == 'Patient' || (this.router.url.includes('patientlist_format'))){
      if(role.role == 'Patient'){
        this.patientApiResponse(role.uhid?role.uhid:role.uhId)
      } else {
        this.patientApiResponse(cardData.uhId?cardData.uhId:cardData.uhid)
      }
    }
  }

  patientApiResponse(uhid){
    let filter = "uhId:" + uhid
    this.loaderService.showSpinner();
    this.baseService.get("GET_PAGE", '', "emr_code_mapping", "system-management",filter).subscribe((result: any) => {
      this.loaderService.hideSpinner();
      if (result && result.resource && result.resource[0]) {
        this.codeArrays.problemIcdTen = result.resource[0].icd10_problem_code?.split(',')
        this.codeArrays.problemIcdNine = result.resource[0].icd9_problem_code?.split(',')
        this.codeArrays.snomed = result.resource[0].snomedct_problem_code?.split(',')
        this.codeArrays.rxcuiMedication = result.resource[0].rxcui_medication_code?.split(',')
        this.codeArrays.ndcMedication = result.resource[0].ndc_medication_code?.split(',')
        this.codeArrays.labtest = result.resource[0].loinc_lab_test_code?.split(',')
        this.codeArrays.cptProcedure = result.resource[0].cpt_procedure_code?.split(',')
        if (this['input'] == 'problem') {
          this.problem()
          if(result.resource[0].snomedct_problem_code != '' && result.resource[0].snomedct_problem_code != undefined){
            this.getDetailsOnLoad({code:this.radioArray[2].code},this.codeArrays.snomed)
          } else if(result.resource[0].icd9_problem_code != '' && result.resource[0].icd9_problem_code != undefined) {
            this.getDetailsOnLoad({code:this.radioArray[1].code},this.codeArrays.problemIcdNine)
          } else if(result.resource[0].icd10_problem_code != '' && result.resource[0].icd10_problem_code != undefined){
            this.getDetailsOnLoad({code:this.radioArray[0].code},this.codeArrays.problemIcdTen)
          }
        }
        if (this['input'] == 'medication') {
          this.medication()
          if(result.resource[0].rxcui_medication_code != '' && result.resource[0].rxcui_medication_code != undefined){
            this.getDetailsOnLoad({code:this.radioArray[0].code},this.codeArrays.rxcuiMedication)
          } else if(result.resource[0].ndc_medication_code != '' && result.resource[0].ndc_medication_code != undefined) {
            this.getDetailsOnLoad({code:this.radioArray[1].code},this.codeArrays.ndcMedication)
          }
        }
        if (this['input'] == 'labtest') {
          this.labtest()
          if(result.resource[0].loinc_lab_test_code != '' && result.resource[0].loinc_lab_test_code != undefined){
            this.getDetailsOnLoad({code:this.radioArray[0].code},this.codeArrays.labtest)
          }
        }
        if (this['input'] == 'procedure') {
          this.procedure()
          if(result.resource[0].cpt_procedure_code != '' && result.resource[0].cpt_procedure_code != undefined){
            this.getDetailsOnLoad({code:this.radioArray[0].code},this.codeArrays.cptProcedure)
          }
        }
        this.code = this.radioArray[0].code
      }
    })
  }

  problem() {
    this.radioArray = [
      {
        key: 'ICD10CM',
        name: 'ICD-10 CM',
        examples: this.codeArrays.problemIcdTen,
        code: '2.16.840.1.113883.6.90',
        heading:'Diagnosis'
      },
      {
        key: 'ICD9CM',
        name: 'ICD-9 CM',
        examples: this.codeArrays.problemIcdNine,
        code: '2.16.840.1.113883.6.103',
        heading:'Diagnosis'
      },
      {
        key: 'Snomed',
        name: 'Snomed CT',
        examples: this.codeArrays.snomed,
        code: '2.16.840.1.113883.6.96',
        heading:'Diagnosis'
      }
    ]
  }

  medication() {
    this.radioArray = [
      {
        key: 'RXCUI',
        name: 'RXCUI',
        examples: this.codeArrays.rxcuiMedication,
        code: '2.16.840.1.113883.6.88',
        heading:'Medication'
      },
      {
        key: 'NDC',
        name: 'NDC',
        examples: this.codeArrays.ndcMedication,
        code: '2.16.840.1.113883.6.69',
        heading:'Medication'
      }
    ]
  }

  labtest() {
    this.radioArray = [
      {
        key: 'LOINC',
        name: 'LOINC',
        examples: this.codeArrays.labtest,
        code: '2.16.840.1.113883.6.1',
        heading:'Lab Test'
      }
    ]
  }

  procedure() {
    this.radioArray = [
      {
        key: 'CPT',
        name: 'CPT',
        examples: this.codeArrays.cptProcedure,
        code: '2.16.840.1.113883.6.12',
        heading:'Procedure'
      }
    ]
  }

  feedradioClicked(e) {
    this.code = e
  }


  getDetails(a,e)
  {
    if(a == undefined){
      a = {}
      a['code'] = this.code
    }
    this.loaderService.showSpinner();
    this.apiCall(a,e)
  }

  apiCall(a,e,call?){
    this.baseService.get("GET_MEDLINE_DATA_V1", `cs:${a.code},c:${e}`, "emrpatient", "emr").subscribe((result: any) => {
      this.loaderService.hideSpinner();
      if (result && result.resource && result.resource[0] && result.resource[0].clinicalCounsellingGivenTo) {
        var abc = JSON.parse(result.resource[0].clinicalCounsellingGivenTo)
        if(abc?.feed?.entry?.length < 1){
          this.alert.error("No data available");
        } else {
          if(call == 'loadcall'){
            this._medlineDetails.push(abc.feed.entry[0])
          } else {
            this._medlineDetails = abc.feed.entry
          }
        }
      } else {
        this.alert.error("No data available");
      }
    })
  }

  getDetailsOnLoad(a,e){
      e.forEach(element => {
       this.apiCall(a,element,'loadcall') 
      });
  }

}
